import React from 'react';

import styled from 'styled-components';

import { ModalTitle } from '@atlaskit/modal-dialog';
import type { Appearance } from '@atlaskit/modal-dialog';

const Wrapper = styled.div`
  padding: 24px 24px 22px;
`;

const Subtitle = styled.p`
  font-size: 14px;
  padding-top: 16px;
  margin: 0;
`;

const IconContainer = styled.div`
  padding-right: 7px;
`;

type Props = {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  appearance?: Appearance;
};
export default function ModalHeader({
  title,
  subtitle,
  icon,
  appearance,
}: Props): JSX.Element {
  return (
    <Wrapper>
      <ModalTitle appearance={appearance}>
        {icon ? <IconContainer>{icon}</IconContainer> : null} {title}
      </ModalTitle>
      {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
    </Wrapper>
  );
}
